import { render, staticRenderFns } from "./MapDefaultViewer.vue?vue&type=template&id=0b7fe5c2&scoped=true&"
import script from "./MapDefaultViewer.vue?vue&type=script&lang=js&"
export * from "./MapDefaultViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fe5c2",
  null
  
)

export default component.exports